import React from 'react';
import { Box } from '@mui/material';
import './OrganizationEarningsTableSkeleton.css';

const OrganizationEarningsTableSkeleton = ({ rows = 8 }) => {
  return (
    <Box className="org-earnings-skeleton-container">
      <table className="org-earnings-skeleton-table">
        <thead>
          <tr>
            <th className="org-earnings-skeleton-th">
              <Box className="org-earnings-skeleton-box header-skeleton" />
            </th>
            <th className="org-earnings-skeleton-th">
              <Box className="org-earnings-skeleton-box header-skeleton" />
            </th>
            <th className="org-earnings-skeleton-th">
              <Box className="org-earnings-skeleton-box header-skeleton" />
            </th>
            <th className="org-earnings-skeleton-th">
              <Box className="org-earnings-skeleton-box header-skeleton" />
            </th>
            <th className="org-earnings-skeleton-th">
              <Box className="org-earnings-skeleton-box header-skeleton" />
            </th>
            <th className="org-earnings-skeleton-th">
              <Box className="org-earnings-skeleton-box header-skeleton" />
            </th>
            <th className="org-earnings-skeleton-th">
              <Box className="org-earnings-skeleton-box header-skeleton" />
            </th>
            <th className="org-earnings-skeleton-th">
              <Box className="org-earnings-skeleton-box header-skeleton" />
            </th>
            <th className="org-earnings-skeleton-th">
              <Box className="org-earnings-skeleton-box header-skeleton" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={rowIndex} className="org-earnings-skeleton-row">
              <td className="org-earnings-skeleton-td">
                <Box className="org-earnings-skeleton-instructor">
                  <Box className="org-earnings-skeleton-avatar" />
                  <Box className="org-earnings-skeleton-box name-skeleton" />
                </Box>
              </td>
              <td className="org-earnings-skeleton-td">
                <Box className="org-earnings-skeleton-box text-skeleton" />
              </td>
              <td className="org-earnings-skeleton-td">
                <Box className="org-earnings-skeleton-box badge-skeleton" />
              </td>
              <td className="org-earnings-skeleton-td">
                <Box className="org-earnings-skeleton-learner">
                  <Box className="org-earnings-skeleton-avatar small" />
                  <Box className="org-earnings-skeleton-box name-skeleton" />
                </Box>
              </td>
              <td className="org-earnings-skeleton-td">
                <Box className="org-earnings-skeleton-box text-skeleton" />
              </td>
              <td className="org-earnings-skeleton-td">
                <Box className="org-earnings-skeleton-box text-skeleton short" />
              </td>
              <td className="org-earnings-skeleton-td">
                <Box className="org-earnings-skeleton-box text-skeleton short" />
              </td>
              <td className="org-earnings-skeleton-td">
                <Box className="org-earnings-skeleton-box text-skeleton short" />
              </td>
              <td className="org-earnings-skeleton-td">
                <Box className="org-earnings-skeleton-box badge-skeleton" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default OrganizationEarningsTableSkeleton;
